/**************************************
Badger Labs - LIMS Vuex Store
**************************************/

const store = new Vuex.Store({
    state: {

		// Loaded using local-storage.js
		// Locally Stored Data
		clientList: [],
		clientListLoaded: false,
		testList: [],
        testListLoaded: false,
		drnTestList: [],
        dnrTestListLoaded: false,
        testMethodLimitsMap: [],
        testMethodLimitsMapLoaded: false,
        importParameterTranslationMap: [],
        importParameterTranslationMapLoaded: false,
		overdueJobList: [],
		overdueJobListLoaded: false,
		priceList: [],
		priceListLoaded: false,
		sampleList: [],
        sampleListLoaded: false,
        testComboList: [],
        testComboListLoaded: false,
        outlierStandardDeviationRatio: null,
		outlierStandardDeviationRatioLoaded: false,

		// Loaded using local-storage.js
		// Dropdown Options
		collectionMethodOptions: [],
		collectionMethodOptionsLoaded: false,
		deliveryModeOptions: [],
		deliveryModeOptionsLoaded: false,
		jobStatusOptions: [],
		jobStatusOptionsLoaded: false,
		locationOptions: [],
		locationOptionsLoaded: false,
		matrixOptions: [],
		matrixOptionsLoaded: false,
		preservedByOptions: [],
		preservedByOptionsLoaded: false,
		sampledByOptions: [],
		sampledByOptionsLoaded: false,
		unitsOptions: [],
		unitsOptionsLoaded: false,
        analyteOptions: [],
		analyteOptionsLoaded: false,

        /**************************************
        Jobs
        used on the sample entry screen
        **************************************/
        jobs: [],
        jobData: null,

        /**************************************
        Samples
        used on the sample entry screen
        **************************************/
        samples: [],
        sampleDuplicationChecklist: [],
        preservedByOptions: [],


        states: [ 'WI', 'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID',
       'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV',
       'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN',
       'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WY' ],
    },

    getters: {
        // /**************************************
        // Test Combos
        // **************************************/
        // testComboName: state => {
        //     return state.testCombo ? state.testCombo.text : '';
        // },
        // testComboId: state => {
        //     return state.testCombo ? state.testCombo.id : '';
        // },

        outlierStandardDeviationRatio: state => state.outlierStandardDeviationRatio,
    },









    mutations: {
		// Generic Setter using { fieldName: x, value: y } as the payload
		set: function( state, payload ){
			state[ payload.fieldName ] = payload.value;
			state[ payload.fieldName + 'Loaded' ] = true;
		},

        /**************************************
        Clients
        **************************************/
        setClient( state, client ) {
            state.client = client;
        },

        deleteClient( state ) {
            state.clients.splice( state.clients.indexOf( state.client ), 1 );
        },

        /**************************************
        Samples
        **************************************/
        setSampleDuplicationChecklist( state, checklist ) {
            state.sampleDuplicationChecklist = checklist;
        },
    },


    actions: {

        localLoadSampleDuplicationChecklist ( { commit } ) {
            let checklist = [];
            if ( sb_storageAvailable('localStorage')
                && localStorage.getItem( 'sampleDuplicationChecklist' ) ) {
                checklist = JSON.parse( localStorage.getItem( 'sampleDuplicationChecklist' ) );
            } else {
                // load Default
                checklist = new SampleDuplicationChecklist();
            }
            commit( 'setSampleDuplicationChecklist', checklist );
        },
        localUpdateSampleDuplicationChecklist ( { commit }, checklist ) {
            if ( sb_storageAvailable('localStorage') ) {
                let stringifiedChecklist = JSON.stringify( checklist );
                localStorage.setItem( 'sampleDuplicationChecklist', stringifiedChecklist );
            }
        },

    },
});
